import { useContext } from 'react';
import ServicesContext from '../../contextProviders/ServicesContext';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';

const useIsDashboardEnabled = () => {
  const services = useContext(ServicesContext);
  const { loggedUser } = useContext(LoggedUserContext);
  const isLogged = !!loggedUser;

  const inboxIsEnabled =
    services && services.inbox && services.inbox.enabled === true;
  const performIsEnabled =
    services && services.perform && services.perform.enabled === true;
  const academyIsEnabled =
    services && services.academy && services.academy.enabled === true;

  return isLogged && (inboxIsEnabled || performIsEnabled || !academyIsEnabled);
};

export default useIsDashboardEnabled;
